module.exports = __webpack_public_path__ + "static/media/Madhav pudipeddi.ca614f8c.jpg";